import { IGoogleMapOptions } from '@lib/geo/google/map';

export type MapDefaultOptions = IGoogleMapOptions | (() => IGoogleMapOptions);
